import styled from 'styled-components';

// Material-UI
import Popover from '@material-ui/core/Popover';

// *************************************
// STYLED COMPONENTS                           
// *************************************

// Popover
export const StyledPopover = styled(Popover)`
  .MuiPopover-paper {
    border-radius: 6px;
    box-shadow: ${(props) => props.theme.shadows.depth4};
  }
`;